import { DynamicStandaloneProseProps } from '@/components/Prose';
import { StandaloneComponent } from '@/types/component';
import { Richtextbox } from './Richtextbox';

export interface StandaloneRichtextboxProps extends DynamicStandaloneProseProps {}

export const StandaloneRichtextbox: StandaloneComponent<StandaloneRichtextboxProps> = (props) => {
  return <Richtextbox {...props} />;
};

export default StandaloneRichtextbox;
